import React from 'react';
import "./Section1.css";
import { Link } from 'react-router-dom';
import aboutImage from '../Images/Business_advisor.webp';

const Section1 = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="introduction-section">
        <div className="content-wrapper">
          <div className="text-container">
            <h1>
              Tax Filing <span className="data-d">Simple, Accurate & Worry-Free</span>
            </h1>
          </div>
        </div>
        <Link to="/signup">
          <button className="haveatalk">Register Now</button>
        </Link>
      </section>

      {/* About Us Section */}
      <section className="abt-aboutus-section">
        <div className="abt-para-us">
          <h1 className="abt-aboutus-heading">
            Your Reliable <span className="abt-business-co">Tax & Business</span> Advisor
          </h1>
          <p>
            At <strong>Litax</strong>, we deliver comprehensive tax solutions and business advisory services, helping both individuals and companies achieve their financial objectives with ease.
          </p>
          <p>
            Our dedicated experts take care of your taxes, compliance, and business strategy meticulously, so you can concentrate on expanding your business and reaching new milestones.
          </p>
          <p>
            We don’t just offer advice; we stand by you as partners, building a secure and stress-free financial future together.
          </p>
        </div>
        <div className="abt-img-aboutus">
          <img src={aboutImage} alt="Tax & Business Services" className="abt-img-about" />
        </div>
      </section>
    </div>
  );
};

export default Section1;
